import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "select-dashed" }
const _hoisted_2 = { class: "select-dashed__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectMultiComponent = _resolveComponent("SelectMultiComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title) + ":", 1),
    _createVNode(_component_SelectMultiComponent, {
      modelValue: _ctx.model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
      options: _ctx.options as never[],
      canClear: _ctx.canClearSelect,
      placeholder: "Выберите",
      classSelect: "multiselect--empty-borders"
    }, null, 8, ["modelValue", "options", "canClear"])
  ]))
}